import { Link, useNavigate } from "react-router-dom";
import Navbar from "../../components/navbar/navbarComponent";
import { useState } from "react";
import SubirFotoComponent from "./subirFoto";
import { useDispatch } from "react-redux";
import { limpiarFoto } from "../../redux/actions";
import ErrorModal from "../../components/modals/errorModal";
import { CameraIcon, FileUploadIcon, DoublePlayIcon, BackArrowIcon } from "../../components/icons/SvgIcons";


function OpcionesFotoComponent() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [errorModal, setErrorModal] = useState({ show: false, message: "" });
  const openErrorModal = (message) => setErrorModal({ show: true, message });
  const closeErrorModal = () => setErrorModal({ show: false, message: "" });

  const [imagen, setImagen] = useState(null);

  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
  const [preview, setPreview] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    if (!file.type.startsWith("image/")) {
      openErrorModal("Por favor, selecciona un archivo de imagen válido.");
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      openErrorModal("La imagen es demasiado grande. Selecciona una de menos de 5MB.");
      return;
    }


    // Crear vista previa
    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);

    // Guardar el archivo en el estado
    setImagen(file);

  };

  const handleBack = () => {
    setImagen(null);
  };

  const handleVolver = () => {
    navigate(-1);
  };

  //----Limpiar store si el secuestro se sube sin foto-----//
  const handlePostearSinFoto = async () => {
    await dispatch(limpiarFoto()); // Limpiar foto del store
    navigate("/ingreso_confirmacion");
  };

  return (
    <div>
      <Navbar />
      {!imagen ? (
        <div className="flex min-h-screen flex-col  items-center bg-[#F5FAFF] gap-8 ">
          <div class="flex flex-col justify-center items-start sm:items-center mt-[1rem] sm:mt-[4rem] w-[20rem] sm:w-[32rem]">
            <div class="text-[#3d4245] sm:text-[2rem] text-[1rem] font-bold font-inter">
              Nuevo ingreso
            </div>
            <div class="text-[#687073] sm:text-lg text-s font-medium font-inter">
              Ingresa un nuevo vehículo al corralón
            </div>
          </div>

          <div className="w-[20rem] sm:w-[32rem] h-[56.40px] flex-col justify-start items-start gap-1 inline-flex">
            <div className="self-stretch justify-start items-center inline-flex">
              <div className="w-[33.40px] h-[33.40px] px-[5.01px] py-[6.68px] bg-[#0477ad] rounded-[33.40px] border-2 border-[#0477ad] justify-center items-center gap-[3.34px] flex">
                <div className="w-5 h-5 relative" />
              </div>
              <div className="grow shrink basis-0 h-[2.50px] bg-[#0477ad]" />
              <div className="w-[33.40px] h-[33.40px] px-[5.01px] py-[6.68px] bg-[#0477ad] rounded-[33.40px] border-2 border-[#0477ad] justify-center items-center gap-[3.34px] flex">
                <div className="w-5 h-5 relative" />
              </div>
              <div className="grow shrink basis-0 h-[2.50px] bg-[#0477ad]" />
              <div className="w-[33.40px] h-[33.40px] p-[3.34px] bg-[#c5dfff] rounded-[33.40px] border-2 border-[#0477ad]" />
            </div>
            <div className="self-stretch px-1 justify-between items-start inline-flex">
              <div className="text-[#3d4245] text-base font-semibold font-inter">
                Acta
              </div>
              <div className="text-[#3d4245] text-base font-semibold font-inter">
                Detalles
              </div>
              <div className="text-[#3d4245] text-base font-semibold font-inter">
                Foto
              </div>
            </div>
          </div>

          <div className="my-[1rem]  flex-col justify-start items-start gap-3 inline-flex mx-[1rem]">
            <Link
              to="/ingreso_foto"
              className="self-stretch px-4 py-7 bg-white rounded-lg border border-[#c5dfff] justify-start items-center gap-2.5 inline-flex"
            >
              <div className="w-[49px] h-[49px] relative">
                <CameraIcon className="size-18 stroke-[#0477ad]" />
              </div>
              <div className="flex-col justify-start items-start gap-1 inline-flex">
                <div className="text-[#0477ad] text-lg font-bold font-inter">
                  Tomar foto
                </div>
                <div className="text-[#687073] text-sm font-normal font-inter">
                  Capturar una foto del vehículo ingresado
                </div>
              </div>
            </Link>
            <label
              for="file-upload"
              htmlFor="file-upload"
              className="self-stretch px-4 py-7 bg-white rounded-lg border border-[#c5dfff] justify-start items-center gap-2.5 inline-flex cursor-pointer"
            >
              <div className="w-[49px] h-[49px] relative">
                <FileUploadIcon className="size-18 stroke-[#0477ad]" />
              </div>
              <div className="flex-col justify-start items-start gap-1 inline-flex">
                <div className="text-[#0477ad] text-lg font-bold font-inter">
                  Subir foto
                </div>
                <div className="text-[#687073] text-sm font-normal font-inter">
                  Cargar una foto del dispositivo
                </div>
              </div>

              <input
                type="file"
                id="file-upload"
                className="hidden"
                onChange={handleFileChange}
              />
            </label>
            <button
              onClick={handlePostearSinFoto}
              className="self-stretch px-4 py-7 bg-white rounded-lg border border-[#c5dfff] justify-start items-center gap-2.5 inline-flex"
            >
              <div className="w-[49px] h-[49px] relative">
                <DoublePlayIcon className="size-18 stroke-[#0477ad]" />
              </div>
              <div className="flex-col justify-start items-start gap-1 inline-flex">
                <div className="text-[#0477ad] text-lg font-bold font-inter">
                  Saltar este paso
                </div>
                <div className="text-[#687073] text-sm font-normal font-inter">
                  Capturar una foto mas tarde
                </div>
              </div>
              <div className="p-0.5 justify-start items-center gap-2.5 flex" />
            </button>
            <button
              onClick={handleVolver}
              className="self-stretch px-4 py-7 bg-white rounded-lg border border-[#c5dfff] justify-start items-center gap-2.5 inline-flex"
            >
              <div className="w-[49px] h-[49px] relative">
                <BackArrowIcon className="size-18 stroke-[#0477ad]" />
              </div>
              <div className="flex-col justify-start items-start gap-1 inline-flex">
                <div className="text-[#0477ad] text-lg font-bold font-inter">
                  Volver atrás
                </div>
                <div className="text-[#687073] text-sm font-normal font-inter">
                  Regresar a los detalles del ingreso
                </div>
              </div>
            </button>
          </div>
        </div>
      ) : (
        <SubirFotoComponent imagen={imagen} preview={preview} handleBack={handleBack} />
      )}
      {errorModal.show && (
        <ErrorModal
          closeErrorModal={closeErrorModal}
          message={errorModal.message}
        />
      )}
    </div>
  );
}

export default OpcionesFotoComponent;
